module.exports = __webpack_public_path__ + "static/Cameron Nuckols signature-cfc9f6493270253c5a8cb565afe4a3f0.svg";